/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { ApplicationNoteDto } from "./ApplicationNoteDto";
import {
  ApplicationNoteDtoFromJSON,
  ApplicationNoteDtoFromJSONTyped,
  ApplicationNoteDtoToJSON,
  ApplicationNoteDtoToJSONTyped,
} from "./ApplicationNoteDto";
import type { JobApplicationStatus } from "./JobApplicationStatus";
import {
  JobApplicationStatusFromJSON,
  JobApplicationStatusFromJSONTyped,
  JobApplicationStatusToJSON,
  JobApplicationStatusToJSONTyped,
} from "./JobApplicationStatus";
import type { ApplicationAnswerDto } from "./ApplicationAnswerDto";
import {
  ApplicationAnswerDtoFromJSON,
  ApplicationAnswerDtoFromJSONTyped,
  ApplicationAnswerDtoToJSON,
  ApplicationAnswerDtoToJSONTyped,
} from "./ApplicationAnswerDto";
import type { ApplicationActivityDto } from "./ApplicationActivityDto";
import {
  ApplicationActivityDtoFromJSON,
  ApplicationActivityDtoFromJSONTyped,
  ApplicationActivityDtoToJSON,
  ApplicationActivityDtoToJSONTyped,
} from "./ApplicationActivityDto";

/**
 *
 * @export
 * @interface ApplicationDetail
 */
export interface ApplicationDetail {
  /**
   *
   * @type {string}
   * @memberof ApplicationDetail
   */
  applicationId: string;
  /**
   *
   * @type {string}
   * @memberof ApplicationDetail
   */
  role: string;
  /**
   *
   * @type {string}
   * @memberof ApplicationDetail
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof ApplicationDetail
   */
  email: string;
  /**
   *
   * @type {JobApplicationStatus}
   * @memberof ApplicationDetail
   */
  status: JobApplicationStatus;
  /**
   *
   * @type {string}
   * @memberof ApplicationDetail
   */
  source?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApplicationDetail
   */
  referredBy?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApplicationDetail
   */
  location?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApplicationDetail
   */
  portfolioUrl?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApplicationDetail
   */
  hoursPerWeek?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApplicationDetail
   */
  resumeS3Key?: string | null;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof ApplicationDetail
   */
  submittedAt: OffsetDateTime;
  /**
   *
   * @type {Array<ApplicationAnswerDto>}
   * @memberof ApplicationDetail
   */
  answers: Array<ApplicationAnswerDto>;
  /**
   *
   * @type {Array<ApplicationNoteDto>}
   * @memberof ApplicationDetail
   */
  notes: Array<ApplicationNoteDto>;
  /**
   *
   * @type {Array<ApplicationActivityDto>}
   * @memberof ApplicationDetail
   */
  activity: Array<ApplicationActivityDto>;
  /**
   *
   * @type {string}
   * @memberof ApplicationDetail
   */
  salaryExpectation?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApplicationDetail
   */
  currency?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApplicationDetail
   */
  englishLevel?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApplicationDetail
   */
  teamMemberId?: string | null;
}

/**
 * Check if a given object implements the ApplicationDetail interface.
 */
export function instanceOfApplicationDetail(
  value: object,
): value is ApplicationDetail {
  if (!("applicationId" in value) || value["applicationId"] === undefined)
    return false;
  if (!("role" in value) || value["role"] === undefined) return false;
  if (!("name" in value) || value["name"] === undefined) return false;
  if (!("email" in value) || value["email"] === undefined) return false;
  if (!("status" in value) || value["status"] === undefined) return false;
  if (!("submittedAt" in value) || value["submittedAt"] === undefined)
    return false;
  if (!("answers" in value) || value["answers"] === undefined) return false;
  if (!("notes" in value) || value["notes"] === undefined) return false;
  if (!("activity" in value) || value["activity"] === undefined) return false;
  return true;
}

export function ApplicationDetailFromJSON(json: any): ApplicationDetail {
  return ApplicationDetailFromJSONTyped(json, false);
}

export function ApplicationDetailFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ApplicationDetail {
  if (json == null) {
    return json;
  }
  return {
    applicationId: json["applicationId"],
    role: json["role"],
    name: json["name"],
    email: json["email"],
    status: JobApplicationStatusFromJSON(json["status"]),
    source: json["source"] == null ? undefined : json["source"],
    referredBy: json["referredBy"] == null ? undefined : json["referredBy"],
    location: json["location"] == null ? undefined : json["location"],
    portfolioUrl:
      json["portfolioUrl"] == null ? undefined : json["portfolioUrl"],
    hoursPerWeek:
      json["hoursPerWeek"] == null ? undefined : json["hoursPerWeek"],
    resumeS3Key: json["resumeS3Key"] == null ? undefined : json["resumeS3Key"],
    submittedAt: json["submittedAt"],
    answers: (json["answers"] as Array<any>).map(ApplicationAnswerDtoFromJSON),
    notes: (json["notes"] as Array<any>).map(ApplicationNoteDtoFromJSON),
    activity: (json["activity"] as Array<any>).map(
      ApplicationActivityDtoFromJSON,
    ),
    salaryExpectation:
      json["salaryExpectation"] == null ? undefined : json["salaryExpectation"],
    currency: json["currency"] == null ? undefined : json["currency"],
    englishLevel:
      json["englishLevel"] == null ? undefined : json["englishLevel"],
    teamMemberId:
      json["teamMemberId"] == null ? undefined : json["teamMemberId"],
  };
}

export function ApplicationDetailToJSON(json: any): ApplicationDetail {
  return ApplicationDetailToJSONTyped(json, false);
}

export function ApplicationDetailToJSONTyped(
  value?: ApplicationDetail | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    applicationId: value["applicationId"],
    role: value["role"],
    name: value["name"],
    email: value["email"],
    status: JobApplicationStatusToJSON(value["status"]),
    source: value["source"],
    referredBy: value["referredBy"],
    location: value["location"],
    portfolioUrl: value["portfolioUrl"],
    hoursPerWeek: value["hoursPerWeek"],
    resumeS3Key: value["resumeS3Key"],
    submittedAt: value["submittedAt"],
    answers: (value["answers"] as Array<any>).map(ApplicationAnswerDtoToJSON),
    notes: (value["notes"] as Array<any>).map(ApplicationNoteDtoToJSON),
    activity: (value["activity"] as Array<any>).map(
      ApplicationActivityDtoToJSON,
    ),
    salaryExpectation: value["salaryExpectation"],
    currency: value["currency"],
    englishLevel: value["englishLevel"],
    teamMemberId: value["teamMemberId"],
  };
}
